import { gql } from 'apollo-client-ppc';

export const fetchOfferingForProductForOrderReview = gql`
  query fetchOfferingForProductForOrderReview(
    $id: ID!
    $includeExperimentalProducts: Boolean
    $isAddOnsSearchEnabled: Boolean
    $isStatuspageEnabled: Boolean
    $isTeamWorkCollectionEnabled: Boolean
    $isStrategyCollectionEnabled: Boolean
  ) {
    nativeCatalogItem: partnerNativeCatalogItem(
      id: $id
      includeExperimentalProducts: $includeExperimentalProducts
      isAddOnsSearchEnabled: $isAddOnsSearchEnabled
      isStatuspageEnabled: $isStatuspageEnabled
      isTeamWorkCollectionEnabled: $isTeamWorkCollectionEnabled
      isStrategyCollectionEnabled: $isStrategyCollectionEnabled
    ) {
      id
      offering {
        id
        offeringName
        pricingType
        status
        offeringGroup
        relationshipRequirements {
          level
          side
          type
        }
        availableAddOns {
          offeringId
          name
        }
      }
    }
  }
`;
